import React from 'react';
import { MessageSquare, Wrench } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Link } from 'react-router-dom';

const SecureMessages = () => {
  return (
    <div className="py-20 animate-fade-in">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex p-6 glass-card rounded-2xl mb-6 animate-glow-pulse">
            <MessageSquare className="w-16 h-16 text-primary" />
          </div>

          <h1 className="text-4xl lg:text-5xl font-bold mb-4">
            Secure <span className="gradient-text">Messages</span>
          </h1>

          <p className="text-muted-foreground text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            Create encrypted messages with optional password protection. Share as text, QR, or files.
          </p>

          <div className="glass-card p-12 mb-8">
            <Wrench className="w-12 h-12 text-warning mx-auto mb-4" />
            <h2 className="text-2xl font-semibold mb-4">Tool Under Development</h2>
            <p className="text-muted-foreground leading-relaxed max-w-xl mx-auto">
              Compose encrypted messages that can only be read with the correct password.
              Share via multiple formats for maximum flexibility.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="glass-card p-6">
              <h3 className="font-semibold mb-2">Password Protected</h3>
              <p className="text-sm text-muted-foreground">Encrypted before sharing</p>
            </div>
            <div className="glass-card p-6">
              <h3 className="font-semibold mb-2">Multiple Formats</h3>
              <p className="text-sm text-muted-foreground">Text, QR code, or file</p>
            </div>
            <div className="glass-card p-6">
              <h3 className="font-semibold mb-2">Clipboard Safe</h3>
              <p className="text-sm text-muted-foreground">Auto-clear option</p>
            </div>
          </div>

          <Link to="/explore">
            <Button variant="outline" size="lg" className="glass">
              Back to Tools
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SecureMessages;
